module.exports = __webpack_public_path__ + "img/IL.bd8957ce.png";